import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/site';

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="flex items-center justify-center w-10 h-10 rounded-md bg-accent-500 text-primary-950 font-heading font-black text-lg">
                姐
              </span>
              <span className="font-heading font-bold text-xl text-background-50">{siteConfig.brand}</span>
            </div>
            <p className="text-sm leading-relaxed text-background-200/80 max-w-md">
              {siteConfig.description}
            </p>
            <p className="text-xs text-background-200/50 mt-4 leading-relaxed">
              本站为影视内容资讯演示站点，所有影视作品、演员及资讯内容均为虚构演示素材，仅供前端功能展示。
            </p>
          </div>

          <div>
            <h3 className="font-heading font-semibold text-background-50 mb-4 text-sm tracking-wide">友情链接</h3>
            <ul className="flex flex-col gap-3">
              {siteConfig.friendLinks.map((item) => (
                <li key={item.to + item.label}>
                  <Link
                    to={item.to}
                    className="text-sm text-background-200/70 hover:text-accent-400 transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading font-semibold text-background-50 mb-4 text-sm tracking-wide">联系我们</h3>
            <ul className="flex flex-col gap-3 text-sm text-background-200/70">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400" /> contact@jiejiepengyou.demo
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-accent-400" /> 影视内容编辑部
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-information-line text-accent-400" /> 每日 09:00 - 21:00
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 border-t border-primary-800 mt-10 pt-6">
          <p className="text-xs text-background-200/50">
            © {new Date().getFullYear()} {siteConfig.brand} 影视内容站 · 保留所有权利
          </p>
          <p className="text-xs text-background-200/50">
            内容均为前端演示数据，不提供播放与下载功能
          </p>
        </div>
      </div>
    </footer>
  );
}